import englishMessages from '../i18n/en';
import portugueseMessages from '../i18n/pt';

const i18n = {
  "en-GB": englishMessages,
  pt: portugueseMessages
}

export default locale => i18n[locale] || i18n["en-GB"];